import "core-js/modules/es.parse-int.js";
import { useRouter } from 'next/router';
export function usePackageIndex() {
  var _router$query;

  var router = useRouter();
  return router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.package_index ? parseInt(router.query.package_index) : 0;
}